<template>
  <app-information-msg-component
    :libelleList="warningMessages"
    :canClose="false"
    typeMessage="is-warning"
    classLibelle="has-text-warning-dark">
  </app-information-msg-component>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'user-warning-message',
  props: {
    users: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },
  components: {
    AppInformationMsgComponent,
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    warningMessages() {
      const msg = [];
      this.users.forEach(item => {
        const findMsg = msg.find(m => m.userId === item.id);
        if (findMsg) return;
        const userFind = this.parametre(PARAMETRES_KEYS.utilisateur)
          .find(u => u.id === item.id);
        if (userFind && !userFind.actif) {
          msg.push({
            userId: item.id,
            islink: false,
            libelle: this.$t(item.msg, { name: userFind.decorator.nomPrenom }),
          });
        }
      });
      return msg;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
    } catch (e) {
      messageErreur(this.$i18n);
      throw e;
    } finally {
      loadingComponent.close();
    }
  },
};
</script>
